export function isUUID(uuid) {
  return (
    !!uuid &&
    uuid
      .toString()
      .match(
        '^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$',
      )
  );
}
